import { Avatar, Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getValidAccessToken } from "../../../../utils/tokenUtils";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
export const ConversationList = ({ onSelect, selected }) => {
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    const loadConversations = async () => {
      const token = await getValidAccessToken();
      const res = await axios.get(`${apiUrl}/conversations/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConversations(res.data.data);
    };

    loadConversations();
  }, []);

  return (
    <Box sx={{ width: 280, borderRight: "1px solid #ddd", overflowY: "auto" }}>
      {conversations.map((conv) => (
        <Box
          key={conv.ticket_id}
          onClick={() => onSelect(conv)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            px: 2,
            py: 1.5,
            cursor: "pointer",
            backgroundColor:
              selected?.ticket_id === conv.ticket_id
                ? "rgba(25, 118, 210, 0.08)"
                : "transparent",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
        >
          {/* Avatar */}
          <Avatar sx={{ bgcolor: "primary.main", width: 40, height: 40 }}>
            {conv.username?.charAt(0)?.toUpperCase()}
          </Avatar>

          {/* Text Block */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {/* Username */}
            <Typography
              fontWeight={600}
              noWrap
              sx={{ fontSize: "0.95rem", lineHeight: 1.2 }}
            >
              {conv.username}
            </Typography>

            {/* Ticket ID */}
            <Typography
              variant="caption"
              color="text.secondary"
              noWrap
              sx={{ display: "block", mt: 0.25 }}
            >
              Ticket ID: {conv.ticket_id}
            </Typography>

            {/* Last Message (BELOW ticket id) */}
            <Typography
              variant="body2"
              color="text.secondary"
              noWrap
              sx={{
                fontSize: "0.8rem",
                mt: 0.25,
              }}
            >
              {conv.message_content || "No messages yet"}
            </Typography>
          </Box>

          {/* Timestamp */}
          <Box sx={{ alignSelf: "flex-start" }}>
            <Typography
              variant="caption"
              color="text.secondary"
              noWrap
              sx={{ fontSize: "0.7rem" }}
            >
              {conv.timestamp
                ? new Date(conv.timestamp).toLocaleDateString()
                : ""}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
